import React from 'react'
import './EventFeedBack.css';
import { useLocation } from 'react-router-dom';

const EventFeedBack = () => {
    const location = useLocation();
    const events = location?.state?.events;
    const eventId = (events[0])?.feedback_event_id?.ID_event

    const calculateAverageTripRating = (events) => {
        const totalRating = events.reduce((sum, event) => sum + event.event_rating, 0);
        return events.length > 0 ? (totalRating / events.length).toFixed(2) : 0;
    };
    const averageTripRating = calculateAverageTripRating(events);
    const calculateAverageOrganiserRating = (events) => {
        const totalRating = events.reduce((sum, event) => sum + event?.organiser_rating, 0);
        return events.length > 0 ? (totalRating / events.length).toFixed(2) : 0;
    };
    const averageOrganiserRating = calculateAverageOrganiserRating(events);

    const eventDetails = [
        { heading: "Event ID", content: eventId },
        { heading: "Overall event rating", content: averageTripRating },
        { heading: "Organiser Name", content: events[0]?.feedback_event_id?.organizers },
        { heading: "Overall organiser rating", content: averageOrganiserRating },
    ];

    const tripDetails = [
        { heading: "Trip title", content: events[0]?.feedback_event_id?.trip_title },
        { heading: "Trip Date", content: events[0]?.feedback_event_id?.start_date },
        { heading: "Trip start location", content: events[0]?.feedback_event_id?.start_location },
        { heading: "Destination", content: events[0]?.feedback_event_id?.destination },
    ];
    const Detail = ({ heading, content }) => (
        <div className="details-content-container">
            <h5 className="information-side-heading">{heading}</h5>
            <p className="information-content">{content}</p>
        </div>
    );
    return (

        <>
            <div>
                <div className="event-information-container">
                    <div className="details-container">
                        {eventDetails.map((detail, index) => (
                            <Detail key={index} heading={detail.heading} content={detail.content} />
                        ))}
                    </div>
                    <div className="details-container">
                        {tripDetails.map((detail, index) => (
                            <Detail key={index} heading={detail.heading} content={detail.content} />
                        ))}
                    </div>
                </div>

                <br></br>
                <p className="upcomingsession-text">Reviews({events.length})</p>
                {events.map((eachReview, index) =>
                (<div key={index} className="details-container">
                    <div className="details-content-container">
                        <h5 className="information-side-heading">{index + 1}</h5>
                        <h5 className="information-side-heading1">{eachReview?.feedback_user_id?.profile_id}</h5>
                        <p className="information-content">{eachReview?.feedback_user_id?.firstName} {eachReview?.feedback_user_id?.lastName} </p>
                    </div>
                    <hr className="horizontal-line" />
                    <br></br>
                    <div className="details-content-container">
                        <h5 className="information-side-heading">Event rating</h5>
                        <p className="information-content">{eachReview?.event_rating}</p>
                    </div>
                    <div className="details-content-container">

                        <h5 className="information-side-heading">Organiser rating</h5>
                        <p className="information-content">{eachReview?.organiser_rating}</p>
                    </div>
                    <div className="details-content-container">
                        <h5 className="information-side-heading">Mosted Enjoyed</h5>
                        <p className="information-content">
                            {eachReview?.event_review.join(",  ") || 'Null'}
                        </p>
                    </div>
                    <div className="details-content-container">
                        <h5 className="information-side-heading">Areas to improve</h5>
                        <p className="information-content"> {eachReview?.mbt_experience?.join(",  ") || 'Null'}</p>
                    </div>
                    <div className="details-content-container">
                        <h5 className="information-side-heading">Organiser review</h5>
                        <p className="information-content">
                            {eachReview?.organiser_review?.join(" ") || 'Null'}
                        </p>
                    </div>
                    <div className="details-content-container">

                        <h5 className="information-side-heading">Suggestions</h5>
                        <p className="information-content">
                            {eachReview?.suggestions || 'Null'}
                        </p>
                    </div>
                    <div className="details-content-container">
                        <h5 className="information-side-heading">Join more trips </h5>
                        <p className="information-content">
                            {eachReview?.join_more_trips || 'Null'}
                        </p>
                    </div>
                </div>)
                )}

                <br></br>

            </div>
        </>

    )
}

export default EventFeedBack
